import React from "react";
import { View, Text } from "react-native";

import { CheckBox, OtherText } from "components";

import { styles } from "./styles";

export const DrilledDownQuestion = props => {
  const {
    question,
    selectedOptions,
    selectSubOption,
    setSubOptionOtherText,
    addSubOptionFile,
    removeSubOptionFile,
    scrollDownBy,
    scrollToEnd,
    isEnglish,
    lang,
  } = props;
  const { max_sub_option_selection_count } = question;
  const isSingleSelection = max_sub_option_selection_count === 1;
  const icon = isSingleSelection ? "circle" : "square";
  const size = styles._checkbox?.fontSize;

  const helpMessage = max_sub_option_selection_count
    ? `Please select ${max_sub_option_selection_count} option${
        isSingleSelection ? "" : "s"
      } for each section`
    : "Please select all that apply";

  const otherTextStyles = {
    [isEnglish ? "marginLeft" : "marginRight"]: size + 30,
    [isEnglish ? "marginRight" : "marginLeft"]: 30,
  };

  return (
    <View style={styles.container}>
      <Text style={[styles.helpMessage]}>{helpMessage}</Text>
      {question.options.map(option => {
        const selectedOption = selectedOptions[option.virtual_id] || {};
        return (
          <View key={option.virtual_id} style={styles.subOptions}>
            <Text style={[styles.optionLabel]}>{option[lang]}</Text>
            {option.sub_options.map(subOption => {
              const selectedSubOptions = selectedOption.subOptions || {};
              const selectedSubOption =
                selectedSubOptions[subOption.virtual_id];

              const onCapture = (file, type) => {
                addSubOptionFile(question, option, subOption, file, type);
                setTimeout(() => scrollDownBy(100), 50);
              };

              const removeFile = id =>
                removeSubOptionFile(question, option, subOption, id);

              const checkBoxProps = {
                icon,
                size,
                text: subOption[lang],
                iconRight: !isEnglish,
                checked: !!selectedSubOption,
                onPress: () => {
                  selectSubOption(question, option, subOption);
                  if (subOption.is_other && !selectedSubOption) {
                    setTimeout(() => scrollDownBy(80), 50);
                  }
                },
              };

              const shouldRenderIsOther =
                selectedSubOption && subOption.is_other;

              const otherTextProps = {
                lang,
                option: subOption,
                onCapture,
                removeFile,
                scrollToEnd,
                selectedOption: selectedSubOptions[subOption.virtual_id],
                containerStyle: otherTextStyles,
                onChangeText: text =>
                  setSubOptionOtherText(question, option, subOption, text),
              };

              return (
                <View key={subOption.virtual_id} style={styles.checkbox}>
                  <CheckBox {...checkBoxProps} />
                  {shouldRenderIsOther && <OtherText {...otherTextProps} />}
                </View>
              );
            })}
          </View>
        );
      })}
    </View>
  );
};
